import { VTextField } from 'vuetify/lib';
import { GraphQLField } from 'graphql';
import FieldComponentFactory from './FieldComponentFactory';

export default class TextFieldFactory extends FieldComponentFactory {
  readonly component = VTextField;

  support(field: GraphQLField<any, any, any>): boolean {
    return this.typeInspector.isScalarType(field.type);
  }
}
